import { Log } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';
import { SecurityContextType } from '../models/enums/securityContextType';

const token: any = localStorage.getItem('access_token');
const _logger = Log.create('Announcement-Service');
const T = Translator.create();
let _apiClient: ApiClient;

export class AnnouncementPageService {
    public modalRootDiv: HTMLElement | null = null;

    constructor() {
        _apiClient = new ApiClient();
        
    }

    public async RequestAddAnnouncementAsync(params: any) {
        let method = 'POST';
        if (params.announcementId) {
            method = 'PUT';
        }

        return _apiClient.RequestAsync(method, 'api/announcement', params, token).then((responseData: Response) => {
            return responseData;
        }).catch((response) => {
            return response;
        });
    }

    // Get Announcement List
    public async RequestGetAnnouncementListAsync(params: any) {
        return _apiClient
            .RequestAsync(
                'POST',
                'api/announcement/my',
                {
                    Take: params.take ? params.take : 20,
                    Skip: params.skip ? params.skip : 0,
                    State: params.stateId,
                    SearchedWord: params.searchedWord ? params.searchedWord : '',
                    IsShowOnStartup: params.isShowOnStartup,
                    lastAnnouncementId : params.lastAnnouncementId ? params.lastAnnouncementId : ''
                },
                token
            )
            .then((responseData: Response) => {
                return responseData;
            }).catch((response) => {
                return response;
            });
    }

    // Get Selected Announcement
    public async RequestGetSelectedAnnouncementAsync(announcementId: string) {
        return _apiClient
            .RequestAsync(
                'GET',
                `api/announcement/getannouncementbyid/${announcementId}?port=${window.location.port}&address=${window.location.hostname}&isFromV3=${false}`,
                null
            )
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestDeleteAnnouncementAsync(params: any) {
        return _apiClient.RequestAsync('DELETE', 'api/announcement', params, token).then((responseData: Response) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

    public async RequestCourseAnnouncementsAsync(classId: string, courseId: string, state: number, take: number, skip: number) {
        if (!classId || !courseId) return false;

        return _apiClient
            .RequestAsync(
                'POST',
                'api/announcement/announcements',
                {
                    items: [
                        {
                            ContextId: classId,
                            ContextType: SecurityContextType.Class,
                        },
                        {
                            ContextId: courseId,
                            ContextType: SecurityContextType.Course,
                        },
                    ],
                    State: state,
                    Take: take ? take : 5,
                    Skip: skip ? skip:  0,
                    Address: window.location.hostname,
                    Port: window.location.port,
                },
                token
            )
            .then((responseData: Response) => {
                if (responseData.status !== 200) {
                    Notification.setNotification(
                        'error',
                        T.t('r_course_page_lessonPage_announcements_error_message'),
                        'topRight'
                    );
                    return null;
                } else {
                    return responseData.json();
                }
            })
            .then((result: any) => {
                return result;
            })
            .catch(() => {
                Notification.setNotification(
                    'error',
                    T.t('r_course_page_lessonPage_announcements_error_message'),
                    'topRight'
                );
                return false;
            });
    }

    public async RequestGetUnreadAnnouncementCountAsync(params: any) {
        return _apiClient
            .RequestAsync(
                'GET',
                'api/announcement/unreadcount',
                null,
                token
            )
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestReadAnnouncementAsync() {
        const requestUrl = 'api/announcement/markasreadall';
        
        return _apiClient.RequestAsync('GET', requestUrl).then((responseData: any) => {
            return responseData;
        }).then((result: any) => {
            return result;
        }).catch((response) => {
            return response;
        });
    }

}
